/**
 * Dynamic API base URL.
 *
 * • If VITE_API_URL is set at build time it wins (useful for custom setups).
 * • Otherwise we derive it from the browser's current hostname so the app
 *   works transparently on localhost, LAN, and public domains.
 */
export const API_BASE_URL: string =
  import.meta.env.VITE_API_URL ||
  (window.location.port === '5173' || window.location.port === '4000'
    ? `${window.location.protocol}//${window.location.hostname}:4000`
    : `${window.location.protocol}//${window.location.hostname}`);

/**
 * Fetch wrapper that attaches the JWT Bearer token from localStorage.
 * Use for all requests to protected API endpoints.
 */
export function authFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const token = localStorage.getItem('fsnu_token');
  const headers = new Headers(options.headers);
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return fetch(url, { ...options, headers });
}
